import React from 'react';

const LogoBookMe = () => (
    <div className="flex items-center space-x-2">
      <svg
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        className="text-orange-500"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="3" y="4" width="18" height="16" rx="2" fill="currentColor" />
        <path d="M8 2V6" stroke="white" strokeWidth="2" strokeLinecap="round" />
        <path d="M16 2V6" stroke="white" strokeWidth="2" strokeLinecap="round" />
        <path d="M3 10H21" stroke="white" strokeWidth="2" />
      </svg>
      <span className="text-xl font-bold text-gray-900 dark:text-white">BookMe</span>
    </div>
  );
  
  export default LogoBookMe;
  